import { useAds } from '@xing-com/crate-ads-native-ads';
import { AdTypes } from '@xing-com/crate-common-graphql-types';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { type JobRecommendationVisibleJob } from '@xing-com/crate-jobs-hooks';
import { useFeatures } from '@xing-com/hub';

import { Ad } from '../ad';
import type { ItemWithBanners } from '../helpers';
import { Result } from '../result';
import * as S from '../results.styles';

export type ListType = 'SEARCH' | 'EMPTY_STATE_SEARCH' | 'EMPTY_STATE_RECOS';

type Props = {
  items: (ItemWithBanners | JobRecommendationVisibleJob)[];
  type: ListType;
};

export const ResultsList: React.FC<Props> = ({ items, type }) => {
  const features = useFeatures();
  const { isLoggedOut } = useLoginState();

  const isBasic = features.data?.isBasic;

  const { ads } = useAds({
    adCount: 1,
    adTypes: [AdTypes.VideoAd, AdTypes.WebsiteAd],
    channel: 'jobs_search_web',
    skipQuery: isLoggedOut,
  });
  const ad = ads.length > 0 && ads[0];

  return (
    <S.List>
      {items.map((item, position) => {
        if (item === 'ProJobsUpsellBanner') {
          return (
            <li key="projobs-banner">
              <S.ProJobsUpsellBanner isBasic={isBasic} />
            </li>
          );
        }

        if (item === 'Ad') {
          if (!ad) return null;

          return (
            <li key="ad">
              <Ad ad={ad} position={position} />
            </li>
          );
        }

        return <Result key={item.trackingToken} item={item} type={type} />;
      })}
    </S.List>
  );
};
